import { useCallback, useEffect, useState } from 'react';
import { fetchArticles } from '../services/newsService';

const FIFTEEN_MINUTES = 15 * 60 * 1000;

function useNews(options = {}) {
  const { category, limit = 100, orderBy = 'published_at' } = options;
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const latest = await fetchArticles({ category, limit, orderBy });
      setArticles(latest);
      setError('');
      return latest;
    } catch (requestError) {
      setError(
        requestError.message || 'Unable to retrieve the latest news.'
      );
      return [];
    } finally {
      setLoading(false);
    }
  }, [category, limit, orderBy]);

  useEffect(() => {
    refresh();
    const interval = window.setInterval(refresh, FIFTEEN_MINUTES);
    return () => window.clearInterval(interval);
  }, [refresh]);

  return { articles, loading, error, refresh };
}

export default useNews;